import React from 'react';
import {Image} from "react-bootstrap";

const Header = () => {
    return (
        <div>
            <br/>
            <center><Image src="lockup-without-rule-color-100.jpg" width="60%" /></center>
            <br/>
        </div>
    );
}

export default Header;